import Utility from "@/helper/Utility"
export function CreditCardModel(dict = null) {
    this.agentCode = null
    this.cardNo = null
    this.cardType = null
    this.channelCode = null
    this.currencyCode = null
    this.issuerCountry = null
    this.paymentScheme = null
    this.userId = null
    this.cardHolderName = null
    this.cardTierName = null

    if (dict != null) {
        // set values
        this.agentCode = dict.AgentCode
        this.cardNo = dict.CardNo
        this.cardType = dict.CardType
        this.channelCode = dict.ChannelCode
        this.currencyCode = dict.CurrencyCode
        this.issuerCountry = dict.IssuerCountry
        this.paymentScheme = dict.PaymentScheme
        this.userId = dict.UserId
        this.cardTierName = dict.CardTierName
    }
}

CreditCardModel.prototype.setCardHolderName = function (val) {
    this.cardHolderName = val
    return this
}

CreditCardModel.prototype.getParams = function () {
    let params = {
        cardNo: this.cardNo
    }
    return Utility.cleanObjectEmptyStr(params)
}

export function CreditCardModelBuilder() {
    this.model = new CreditCardModel()
}

CreditCardModelBuilder.prototype.create = function () {
    return this.model
}

CreditCardModelBuilder.prototype.setCardNo = function (cardNo) {
    this.model.cardNo = cardNo
    return this
}

export function CreditCardListModelBuilder() {
    this.model = []
}

/**
 *
 * @returns {Array.<import("@/types/CreditCardModel.d").CreditCardModel>}
 */
CreditCardListModelBuilder.prototype.getList = function () {
    return this.model
}

/**
 *
 * @param {array} rawData
 */
CreditCardListModelBuilder.prototype.parse = function (rawList, cardHolderName = null) {

    for (const item of rawList) {
        this.model.push(new CreditCardModel(item).setCardHolderName(cardHolderName))
    }

    return this
}
